
import React from "react"

export function LoginPanel(props) {

	const [formData, setFormData] = React.useState({
		username: "",
		password: ""
	})

	//console.log(formData)		// Runs on component re-render (when state changes)

	//console.log(props.message)

	function handleChange(event) {

		// Destructure event.target - pull out name, value, type and checked
		const { name, value, type, checked } = event.target
		setFormData(prevData => {
			return {
				...prevData,
				// Square brackets change dynamic string (var) into
				// property name.
				[name]: type === "checkbox" ? checked : value
			}
		})

	}

	function handleSubmit(event) {
		event.preventDefault()		//Don't re-render
		props.login(formData)
	}

	return (
		<div className="login-page">

			<div className="login-form">
				<h1>Login</h1>
				<form onSubmit={handleSubmit}>
					<div className={props.formStatus.fieldErrors && props.formStatus.fieldErrors.includes("username")
							? "login-form-field-error"
							: "login-form-field"}
					>
						<label className="login-form-field-label" htmlFor="username">Username</label>
						<input
							className="login-form-field-component"
							type="text"
							placeholder="Username"
							onChange={handleChange}
							name="username"		// Added name for ID in handleChange
							id="username"
							// Value makes the component and controlled component and there
							// is now just one single source of truth (eg. the data shown in 
							// the input box is the formData). This can be checked by setting
							// two fields to show the same data (and it works).
							value={formData.username}
						/>
					</div>

					<div className=
						{props.formStatus.fieldErrors && props.formStatus.fieldErrors.includes("password")
							? "login-form-field-error"
							: "login-form-field"}
					>

						<label className="login-form-field-label" htmlFor="password">Password</label>
						<input
							className="login-form-field-component"
							type="password"
							placeholder="Password"
							onChange={handleChange}
							name="password"
							value={formData.password}
							id="password"
						/>
						{/* Buttons by default are submit type. 
							If this is not wanted, set button type to "button"
						*/}
					</div>
					<button className="login-form-button">Login</button>
					<p>{props.formStatus.message}</p>
				</form>
			</div>
			<div className="login-form-image">
				<img src="./logo192.png" alt="Intranet" />
			</div>
		</div>
	)
}